import { responsiveClassNames, responsiveVariables } from "../../utilities/helpers.js";
import s from "./inset.module.css";
const getInsetStyles = (value, side) => {
    if (value === undefined)
        return null;
    const suffix = side ? `-${side}` : "";
    const variableName = `--rs-inset${suffix}`;
    const variables = responsiveVariables(variableName, value);
    const classNames = responsiveClassNames(s, `--inset${suffix}`, value, {
        excludeValueFromClassName: true,
    });
    return { classNames, variables };
};
export default getInsetStyles;
